"use client";

import { motion } from "framer-motion";
import Link from "next/link";
import ctaConfig from "@/../config/ctaConfig.json"; // Only import CTA config
import React from 'react'; // Added React import for Fragment

const CTASection = () => {
  return (
    <motion.div 
      className="text-center pb-10 bg-gradient-to-b from-[#121212] via-[#0a2647] to-[#121212] relative w-full"
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.3 }}
      transition={{ duration: 0.23, delay: 0.1 }}
    >
      {/* Removed decorative elements for cleaner design */}
      
      <div className="relative z-10 max-w-[80%] mx-auto px-4">
        <h2 className="text-3xl md:text-5xl font-bold mb-8 text-transparent bg-clip-text bg-gradient-to-r from-white to-blue-100 leading-snug">
          {ctaConfig.whyMMCTA.title.split('\n').map((line, index) => (
            <React.Fragment key={index}>
              {line}
              {index < ctaConfig.whyMMCTA.title.split('\n').length - 1 && <br />}
            </React.Fragment>
          ))}
        </h2>
        <p className="text-slate-300 text-lg mb-10 max-w-2xl mx-auto">{ctaConfig.whyMMCTA.subtitle}</p>
        
        <div className="flex flex-col mx-auto max-w-xl gap-4 mb-10">
          <div className="flex items-start text-left">
            <div className="flex-shrink-0 h-6 w-6 rounded-full bg-green-900/40 flex items-center justify-center mr-3 mt-1 border border-green-500/20">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#10b981" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M20 6 9 17l-5-5" />
              </svg>
            </div>
            <p className="text-slate-300">
              <span className="font-semibold text-white">{ctaConfig.whyMMCTA.feature1Title}</span> {ctaConfig.whyMMCTA.feature1Desc}
            </p>
          </div>
          <div className="flex items-start text-left">
            <div className="flex-shrink-0 h-6 w-6 rounded-full bg-green-900/40 flex items-center justify-center mr-3 mt-1 border border-green-500/20">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#10b981" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M20 6 9 17l-5-5" />
              </svg>
            </div>
            <p className="text-slate-300">
              <span className="font-semibold text-white">{ctaConfig.whyMMCTA.feature2Title}</span> {ctaConfig.whyMMCTA.feature2Desc}
            </p>
          </div>
        </div>
        
        <div className="flex justify-center items-start gap-6">
          {/* Free Trial Button */}
          <div className="flex flex-col items-center">
            <Link href={ctaConfig.whyMMCTA.freeTrialLink} legacyBehavior>
              <a className="inline-block px-6 py-2 rounded-full text-white font-semibold bg-blue-600 hover:bg-blue-700 transition-all duration-100 shadow-lg text-base min-w-[180px] text-center">
                {ctaConfig.whyMMCTA.freeTrialText}
              </a>
            </Link>
            <p className="text-sm text-slate-400 mt-2">{ctaConfig.whyMMCTA.freeTrialSubtext}</p>
          </div>
          {/* Book Demo Button (now matches Free Trial styling) */}
          <div className="flex flex-col items-center">
            <Link href={ctaConfig.whyMMCTA.bookDemoLink} legacyBehavior>
              <a
                className="inline-block px-6 py-2 rounded-full text-white font-semibold bg-blue-600 hover:bg-blue-700 transition-all duration-100 shadow-lg text-base min-w-[180px] text-center"
                target="_blank"
                rel="noopener noreferrer"
              >
                {ctaConfig.whyMMCTA.bookDemoText}
              </a>
            </Link>
            {/* Conditionally render subtext or keep spacer based on config */}
            {ctaConfig.whyMMCTA.bookDemoSubtext && ctaConfig.whyMMCTA.bookDemoSubtext !== 'Spacer' ? (
                <p className="text-sm text-slate-400 mt-2">{ctaConfig.whyMMCTA.bookDemoSubtext}</p>
            ) : (
                <p className="text-sm text-slate-400 mt-2 opacity-0">Spacer</p> 
            )}
          </div>
        </div>
      </div>
    </motion.div>
  );
};

export default CTASection; 